<div class="">
  <div class="flex gap-2 font-semibold text-xl flex-wrap mb-2">
    <!-- customer info -->
    <p-button (onClick)="op.toggle($event)" class="flex-grow-1"
      styleClass="p-button-text user-button flex button-secondary border-round-lg h-3rem w-full">
      <i class="pi pi-user mr-2"></i>
      @if (business) {
        <span class="text-primary ellipsis">{{business.firstName}} {{business.lastName}}</span>
      } @else {
        <span class="text-primary ellipsis">{{customer.FirstName}} {{customer.LastName}}</span>
      }
      <p-popover #op styleClass="border-1 border-round-lg" my="center top" at="right center">
        <div class="flex flex-column max-w-25rem mb-2">
          <div class="mb-3 flex justify-content-center align-items-center py-2 sara-header-bg border-1 border-round-lg">
            <span class="text-white font-bold">Customer Information</span>
          </div>
          @if (business) {
            <div class="p-2">
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Business:</b></div>
                <div class="col pl-4 wrap-text">{{business.businessName}}</div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Name:</b></div>
                <div class="col pl-4 wrap-text">{{business.firstName}} {{business.lastName}}</div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Address:</b></div>
                <div class="col pl-4">
                  <span>{{customer.ServiceAddress.Address1}}</span>
                  @if (customer.ServiceAddress.Address2) {
                    <span>,
                    {{customer.ServiceAddress.Address2}}</span>
                  }
                </div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem white-space-nowrap pl-3"><b>City-State-ZIP:</b></div>
                <div class="col pl-4">{{customer.ServiceAddress.City}},
                {{customer.ServiceAddress.State}} {{customer.ServiceAddress.Zip}}</div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Phone:</b></div>
                <div class="col pl-4">{{business.phone | phone}}</div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Email:</b></div>
                <div class="col pl-4" style="word-break: break-all">{{business.email}}</div>
              </div>
            </div>
          } @else {
            <div class="p-2">
              @if (isSMB()) {
                <div class="mb-2 grid">
                  <div class="col-fixed w-8rem pl-3"><b>Business:</b></div>
                  <div class="col pl-4 wrap-text">{{smbBusinessName()}}</div>
                </div>
              }
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Name:</b></div>
                <div class="col pl-4 wrap-text">{{customer.FirstName}} {{customer.LastName}}</div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Address:</b></div>
                <div class="col pl-4">
                  <span>{{customer.ServiceAddress.Address1}}</span>
                  @if (customer.ServiceAddress.Address2) {
                    <span>,
                    {{customer.ServiceAddress.Address2}}</span>
                  }
                </div>

              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem white-space-nowrap pl-3"><b>City-State-ZIP:</b></div>
                <div class="col pl-4">{{customer.ServiceAddress.City}},
                {{customer.ServiceAddress.State}} {{customer.ServiceAddress.Zip}}</div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Phone:</b></div>
                <div class="col pl-4">{{customer?.ServicePhone | phone}}</div>
              </div>
              <div class="mb-2 grid">
                <div class="col-fixed w-8rem pl-3"><b>Email:</b></div>
                <div class="col pl-4" style="word-break: break-all">{{customer.Email}}</div>
              </div>
            </div>
          }

        </div>
        <div class="max-w-25rem">
          <app-order-menu-customer-credit-info></app-order-menu-customer-credit-info>
        </div>
      </p-popover>
    </p-button>

    @if(featureFlagService.isSeamlessNavigationEnabled()){
      <!-- Navigation -->
      <app-order-navigation></app-order-navigation>
    }

    <!-- Cart -->
    <p-button (onClick)="toggleCart(); cart.toggle($event)"
      styleClass="p-button-text flex button-secondary border-round-lg h-3rem block" class="xl:hidden">
      <div class="flex gap-2">
        <i class="pi pi-bundle-cart mr-2"></i>
        <span class="text-primary cart-text">Cart</span>
      </div>

      <p-popover (onHide)="isCartVisible = false" #cart [dismissable]="true"
        styleClass="border-1 border-round-lg">
        <ng-container [ngTemplateOutlet]="cartContentTemplate"></ng-container>
      </p-popover>
    </p-button>

    <!-- Menu -->
    @if (!isCommercial()) {
      <p-button (onClick)="optools.toggle($event)"
        styleClass="p-button-text flex button-secondary border-round-lg h-3rem">
        <div class="flex gap-5 tools-container-md">
          <span class="text-primary">Tools</span>
          <i class="pi pi-tools ml-4"></i>
        </div>
        <div class="flex tools-container-sm">
          <i class="pi pi-ellipsis-v"></i>
        </div>
        <p-popover #optools styleClass="custom-overlay-width">
          <div class="flex flex-column custom-dropdown-menu">
            <p-button label="Disposition" icon="pi pi-bundle-disposition" styleClass="p-button-text p-0 mb-1"
            (onClick)="dispositionClicked()"></p-button>
            <p-button label="Comments" icon="pi pi-bundle-comments" styleClass="p-button-text p-0 mb-1"
            (onClick)="commentsClicked()"></p-button>
            <p-button label="Sales Help" icon="pi pi-bundle-sales-help" styleClass="p-button-text p-0 mb-1"
            (onClick)="salesHelpClicked()"></p-button>
            <p-button label="Navigation" icon="pi pi-bundle-navigation" styleClass="p-button-text p-0"
            (onClick)="navigationClicked()"></p-button>
          </div>
        </p-popover>
      </p-button>
    }

  </div>
  @if (showChangePackageButton()) {
    <div class="flex align-items-center justify-content-end gap-2 mb-2">
      <span class="font-italic text-sm font-light">Need to change package?</span>
      <p-button label="Go to Package Selection"
        styleClass="p-button-text button-secondary font-semibold text-sm change-package-btn"
        (onClick)="goToPackageSelection()">
      </p-button>
    </div>
  }
</div>



<div class="sales-help-container">
  <p-dialog [modal]="true" [(visible)]="salesHelpVisible"
    [breakpoints]="{ '2400px': '50vw', '1024px': '70vw', '575px': '90vw' }" [closable]="true">

    <ng-template pTemplate="header">
      <div class="flex flex-1 align-items-center justify-content-center sales-help-header">Sales Help</div>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="pt-3 flex flex-column gap-3">

        <div class="flex justify-content-center">
          <span class="sales-help-subtext text-base font-semibold">Browse and click on the resource that you
          need</span>
        </div>

        <div class="flex flex-column gap-1">
          <label class="font-bold text-sm" for="salesHelpSearch">Search</label>
          <span class="p-input-icon-right w-full">
            <i class="pi pi-search"></i>
            <input pInputText id="salesHelpSearch" class="w-full" placeholder="Search by resource title"
              [value]="salesHelpSearch()" (input)="onSalesHelpSearch($any($event.target).value)" />
          </span>
        </div>

        @for (group of filteredSalesHelpResources(); track group.header) {
          <div class="flex align-items-center gap-2 mt-2">
            <div class="border-top-1 surface-300 flex-1"></div>
            <span class="sales-help-group-header font-semibold text-base">{{ group.header }}</span>
            <div class="border-top-1 surface-300 flex-1"></div>
          </div>

          @for (item of group.items; track item.title) {
            <div class="flex flex-column align-items-center gap-1 pb-2 border-bottom-1 border-black-alpha-10">
              <span class="font-semibold text-center text-base font-semibold">{{ item.title }}</span>
              @if (item.description) {
                <span class="text-center text-sm font-normal">{{ item.description }}</span>
              }
              @for (link of item.links; track link.url) {
                <a [href]="link.url" target="_blank" rel="noopener noreferrer"
                  class="sales-help-link flex align-items-center gap-1 font-semibold text-base">
                  {{ link.label }}
                  <i class="pi pi-external-link text-sm"></i>
                </a>
              }
            </div>
          }
        }

        @if (filteredSalesHelpResources().length === 0) {
          <div class="flex justify-content-center py-4 text-600">
            No resources found.
          </div>
        }

      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <p-button label="CLOSE SALES HELP" styleClass="p-button-text font-semibold"
          (onClick)="closeSalesHelp()">
        </p-button>
      </div>
    </ng-template>

  </p-dialog>
</div>

<ng-template #cartContentTemplate>
  <app-order-cart class="max-w-25rem flex flex-column block xl:hidden"></app-order-cart>
</ng-template>
